/**
 * Punto único de configuración de dayjs.
 *
 * Ant Design 5+ abandonó moment y usa dayjs en DatePicker, TimePicker y Calendar.
 * Todo el proyecto importa desde aquí y nunca desde 'dayjs' directamente, para que
 * los plugins y el locale estén siempre registrados: dayjs, a diferencia de moment,
 * no trae nada de serie y un `.utc()` sin su plugin falla en tiempo de ejecución.
 *
 *   import dayjs from 'utiles/dayjs'
 */

import dayjs from 'dayjs'

import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import localeData from 'dayjs/plugin/localeData'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekday from 'dayjs/plugin/weekday'

import 'dayjs/locale/es'

// utc cubre .utc(), .local() y .utcOffset().
dayjs.extend(utc)
// timezone cubre dayjs.tz() y .tz(); depende de utc, así que va después.
dayjs.extend(timezone)
// duration cubre dayjs.duration().
dayjs.extend(duration)
// relativeTime cubre .fromNow().
dayjs.extend(relativeTime)
// updateLocale permite forzar el lunes como primer día de la semana.
dayjs.extend(updateLocale)
// Los cuatro siguientes los necesita el DatePicker de antd por debajo (rc-picker).
dayjs.extend(localeData)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(advancedFormat)
// customParseFormat es la red de seguridad para dayjs(cadena, 'FORMATO').
dayjs.extend(customParseFormat)

dayjs.updateLocale('es', { weekStart: 1 })
dayjs.locale('es')

/**
 * moment exponía estas constantes y dayjs no.
 * En el proyecto sólo se usaba HTML5_FMT.DATE, pero se incluyen las habituales
 * para que una futura sustitución no vuelva a fallar en silencio.
 */
dayjs.HTML5_FMT = {
  DATE: 'YYYY-MM-DD',
  DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
  DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
  DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
  TIME: 'HH:mm',
  TIME_SECONDS: 'HH:mm:ss',
  TIME_MS: 'HH:mm:ss.SSS',
  WEEK: 'GGGG-[W]WW',
  MONTH: 'YYYY-MM',
}

export default dayjs
